import { products } from "../../data/products.js";

export function Footer() {
  const year = new Date().getFullYear();

  return `
    <footer class="site-footer">
      <div class="site-container footer-grid">

        <div class="footer-intro">
          <a href="/" class="footer-brand" data-route aria-label="GR SoftMedia, inicio">
            <img
              src="/assets/gr-softmedia-mark-crop.png"
              alt=""
              width="474"
              height="474"
              loading="lazy"
            />
            <span>GR SoftMedia</span>
          </a>

          <p>
            Productos de software empresarial, implementación e integraciones
            para operaciones que necesitan crecer conectadas.
          </p>

          <div class="social-links">
            <a
              href="https://www.instagram.com/grsoftmedia"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>

            <a
              href="https://www.facebook.com/grsoftmedia"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
          </div>
        </div>

        <div>
          <h2>Productos</h2>
          <ul>
            ${products
              .map(
                (product) =>
                  `<li><a href="${product.route}" data-route>${product.name}</a></li>`
              )
              .join("")}
          </ul>
        </div>

        <div>
          <h2>Servicios</h2>
          <ul>
            <li>Implementación</li>
            <li>Integraciones</li>
            <li>Automatización</li>
            <li>Desarrollo a medida</li>
            <li>Soporte</li>
          </ul>
        </div>

        <div>
          <h2>Contacto</h2>
          <ul>
            <li>
              <a href="mailto:contacto@grsoftmedia.com.do">
                contacto@grsoftmedia.com.do
              </a>
            </li>

            <li>
              <a
                href="https://wa.me/18495925424"
                target="_blank"
                rel="noopener noreferrer"
              >
                +1 849-592-5424
              </a>
            </li>

            <li>República Dominicana</li>
          </ul>
        </div>

      </div>

      <div class="site-container footer-bottom">
        <div>
          <p>
            © ${year} GR SoftMedia. Todos los derechos reservados.
          </p>

          <p class="footer-legal">
            <strong>GR SOFTMEDIA</strong> es un nombre comercial registrado
            en República Dominicana, titularidad de
            <strong>REINALDO ARTURO GARCIA ALMONTE</strong>.
            Registro de Nombre Comercial ONAPI No. 839905.
          </p>
        </div>
      </div>
    </footer>
  `;
}